import(/* webpackMode: "eager" */ "/vercel/path0/ui/app/page.tsx");
